module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-layer",
    style: ('top:' + _vm.y + '; left:' + _vm.x + ';')
  }, [_c('div', {
    staticClass: "layer-content-items"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "layer-content-item",
      on: {
        "click": function($event) {
          _vm.action(item);
        }
      }
    }, [_c('span', {
      staticClass: "icon-layer",
      class: {
        'icon-layer-active': item.active === true, 'icon-layer-desactive': item.active === false
      }
    }), _vm._v("\n            " + _vm._s(_vm.$t(item.label)) + "\n        ")])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45ad3d6f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/MenuLayer.vue
// module id = 3153
// module chunks = 0